/*eslint-disable*/
import en from "./en-US.js";
import ko from "./ko.js";
const messages = { "en-US": en, ko: ko };
export default messages;
